import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { WINDOW } from "../url-api";

@Injectable()
export class ServicioAuth {
  url = environment.backends.URL_API_ROOT + "/api/auth/";

  constructor(
    private http: HttpClient,
    @Inject(WINDOW) private window: Window,
  ) {}

  public getPublicToken() {
    const headers = new HttpHeaders().set("skip", "true");
    return this.http.post<any>(
      this.url + "publico",
      {
        url: this.window.location.hostname,
        idaplicacion: 27,
      },
      { headers },
    );
  }

  public getBasicInfo() {
    return this.http.get<any>(this.url);
  }
}
